<template>
  <div class="h-full w-full">
    <header
      :class="[
        'w-full fixed z-10 bg-white',
        isScrolled ? 'shadow-md' : 'shadow-none',
      ]"
    >
      <div
        class="flex justify-between px-6 md:px-24 items-center"
        @click.self="closeMenus"
      >
        <!-- Logo -->
        <a class="text-[28px] md:text-[55px] py-2 left-5" href="/">
          Núria Jordán
        </a>

        <!-- Botón Hamburguesa -->
        <button
          class="md:hidden flex items-center text-lg focus:outline-none"
          @click="toggleMobileMenu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="w-8 h-8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              :d="
                isMobileMenuOpen
                  ? 'M6 18L18 6M6 6l12 12'
                  : 'M4 6h16M4 12h16M4 18h16'
              "
            />
          </svg>
        </button>

        <!-- Menú principal -->
        <div
          class="hidden md:flex gap-8"
          :class="{ block: !isMobileMenuOpen, hidden: isMobileMenuOpen }"
        >
          <!-- Projectes con submenú en desktop -->
          <div class="relative group">
            <ul>
              <a href="/projects" class="cursor-pointer">
                <li
                  class="text-lg cursor-pointer hover:underline underline-offset-4"
                >
                  Projectes
                </li>
              </a>
            </ul>
            <ul
              class="absolute left-0 transform -translate-x-1/3 bg-white shadow-lg rounded-lg py-2 text-center w-48 z-20 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300"
            >
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/prova"> L'anòmala</a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/modern"> El Modern </a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/wildtech"> Wildtech </a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/sense"> Sense </a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/broomx"> Broomx </a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/units"> Units x Educar </a>
              </li>
            </ul>
          </div>

          <!-- Sobre mi -->
          <div class="relative">
            <p
              class="text-lg cursor-pointer hover:underline underline-offset-4"
            >
              <a href="/presentacio"> Sobre mi </a>
            </p>
          </div>
        </div>

        <!-- Menú móvil -->
        <div
          class="absolute top-full left-0 w-full bg-white shadow-md md:hidden"
          v-show="isMobileMenuOpen"
        >
          <ul class="flex flex-col items-center py-4 space-y-4">
            <!-- Projectes sin submenú en móvil -->
            <li>
              <a href="/projects" class="text-lg">Projectes</a>
            </li>
            <!-- Sobre mi -->
            <li>
              <a href="/presentacio" class="text-lg">Sobre mi</a>
            </li>
          </ul>
        </div>
      </div>
    </header>
    <div
      class="px-12 md:px-48 pt-32 grid grid-cols-1 md:grid-cols-3 gap-8 justify-items-center"
    >
      <div
        v-for="(project, index) in projects"
        :key="index"
        class="w-[70%] md:w-full flex justify-center"
      >
        <a :href="project.link" class="block w-full">
          <div class="relative w-full aspect-square cursor-pointer group">
            <img
              class="w-full h-full object-cover rounded-md opacity-50 group-hover:opacity-100 transition-opacity duration-400"
              :src="project.img"
              :alt="project.alt"
            />
            <div
              class="absolute inset-0 flex justify-center items-center bg-black bg-opacity-50 rounded-md group-hover:opacity-0 transition-all duration-400"
            >
              <div class="text-center text-white">
                <p class="text-xl font-bold">{{ project.title }}</p>
                <p class="text-sm">{{ project.role }}</p>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projectsVisible: false,
      isVisible: false,
      info: "presentacio",
      isMobileMenuOpen: false,
      projects: [
        {
          link: "https://simple.nurjordan.com/prova",
          img: "/img/anomala/anomala1.png",
          alt: "Projecte Anòmala",
          title: "L'anòmala",
          role: "Web & Interactive Developer",
        },
        {
          link: "https://simple.nurjordan.com/broomx",
          img: "/img/broomx/broomx1.png",
          alt: "Projecte Broomx",
          title: "Broomx Interface",
          role: "Web Developer",
        },
        {
          link: "https://simple.nurjordan.com/modern",
          img: "/img/modern/modern1.png",
          alt: "Projecte El Modern",
          title: "Modern",
          role: "Web & Interactive Developer",
        },
        {
          link: "https://simple.nurjordan.com/sense",
          img: "/img/sense/sense1.png",
          alt: "Projecte Sense",
          title: "Sense",
          role: "Web Developer",
        },
        {
          link: "https://simple.nurjordan.com/units",
          img: "/img/units/units1.png",
          alt: "Projecte Units x Educar",
          title: "Units x Educar",
          role: "Web Developer",
        },
        {
          link: "https://simple.nurjordan.com/wildtech",
          img: "/img/wildtech/wildtech1.png",
          alt: "Projecte Wildtech",
          title: "Wildtech",
          role: "Web Developer",
        },
      ],
    };
  },
  methods: {
    toggleProjects() {
      this.projectsVisible = !this.projectsVisible;
      this.isVisible = false;
    },
    toggleInfo() {
      this.isVisible = !this.isVisible;
      this.projectsVisible = false;
    },
    closeMenus() {
      this.projectsVisible = false;
      this.isVisible = false;
    },
    changeInfo(data) {
      this.info = data;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobile() {
      this.isMobileMenuOpen = false;
    },
  },
};
</script>